import { render, staticRenderFns } from "./FailedMessageNotifications.vue?vue&type=template&id=4cf9d079&scoped=true&"
import script from "./FailedMessageNotifications.vue?vue&type=script&lang=js&"
export * from "./FailedMessageNotifications.vue?vue&type=script&lang=js&"
import style0 from "./FailedMessageNotifications.vue?vue&type=style&index=0&id=4cf9d079&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf9d079",
  null
  
)

export default component.exports